/* src/app/about/about.component.css */
.link {
  font-size: 30px;
  display: inline-block;
  margin-top: 15px;
  margin-bottom: 10px;
  margin-right: 10px;
}
/*# sourceMappingURL=about.component.css.map */
